type compares = '>' | '<' | '=' | '!' | '>=' | '<='
type comp = Partial<compares>

export const nfp = (a: number) => a.toLocaleString("ch-DE")
export function compare(
  v1: number,
  v2: number,
  strings: { [k in comp]?: string }
) {
  if (v1 > v2 && strings['>']) {
    return strings['>']
  }
  if (v1 < v2 && strings['<']) {
    return strings['<']
  }
  if (strings['=']) return strings['=']
  return ''
}
// intl.NumberFormat('de-CH', { style: 'percent' }).format(0.1)
export function numberFormat(
  value: number,
  options: { digits?: number; style?: 'percent' } = { digits: 0 }
) {
  const { digits, style } = options
  if (!value) return ''
  let val: number | string =
    digits || digits === 0 ? +value.toFixed(digits) : value

  if (style === 'percent') val = nfp(val)
  return val
}
function plural(value: number, string: { [key: number]: string }) {
  const absValue = Math.abs(value)
  if (absValue === 0) {
    return string[0]
  } else if (absValue === 1) {
    return string[1]
  } else {
    return string[2]
  }
}
export function singularPlural(
  value: number,
  strings: { [key: number]: string }
) {
  let keyValues = Object.keys(strings)
    .map((k) => parseInt(k))
    .sort((a, b) => a - b)

  let ret = strings[keyValues[0]]
  for (let i = 0; i < keyValues.length; i++) {
    if (value >= keyValues[i]) {
      ret = strings[keyValues[i]]
      i = keyValues.length
    }
  }
  return ret
}
class TextBuilderInstance {
  text: string = ''
  textArray: string[] = ['']
  constructor() {
    return this
  }
  array() {
    return this.textArray
  }
  toString() {
    return this.textArray.join(' ')
  }
  break() {
    this.textArray.push('')
    return this
  }
  add(text: string) {
    this.textArray[this.textArray.length - 1] += text
    return this
  }
  compare(v1: number, v2: number, strings: { [k in comp]?: string }) {
    this.textArray[this.textArray.length - 1] += compare(v1, v2, strings) + ' '
    return this
  }
  conditional(value: boolean, strings: { [k in 'true' | 'false']: string }) {
    this.textArray[this.textArray.length - 1] +=
      strings[value ? 'true' : 'false']
    return this
  }
  hash(value: string, strings: { [key: string]: string }) {
    this.textArray[this.textArray.length - 1] += strings[value]
    return this
  }
  plural(value: number, strings: { [key: number]: string }) {
    this.textArray[this.textArray.length - 1] += plural(value, strings) + ' '
    return this
  }
  num(value: number, options: { digits?: number; style?: 'percent' } = {}) {
    this.textArray[this.textArray.length - 1] +=
      numberFormat(value, options) + ''
    return this
  }
  array2List(value: string[], strings: { each: string; last: string }) {
    if (value.length === 0) return this
    if (value.length === 1) {
      this.textArray[this.textArray.length - 1] += value[0]
      return this
    }
    if (value.length === 2) {
      this.textArray[this.textArray.length - 1] +=
        value[0] + ' ' + strings.last + ' ' + value[1]
      return this
    }
    if (value.length > 2) {
      this.textArray[this.textArray.length - 1] +=
        value.slice(0, value.length - 1).join(', ') +
        ' ' +
        strings.last +
        ' ' +
        value[value.length - 1]
      return this
    }
    return this
  }
  range(value: number, strings: { [key: string]: string }) {
    let ranges = Object.entries(strings).map((m) => [
      m[0].split('|').map((m) => +m),
      [m[1]],
    ])

    let ret = ranges[ranges.length-1][1][0]
    for (let i = 0; i < ranges.length; i++) {
      if (value >= ranges[i][0][0] && value < ranges[i][0][1]) {
        ret = ranges[i][1][0] as string
        i = ranges.length
      }
    }
    this.textArray[this.textArray.length - 1] += ret + ' '

    return this
  }
}
export function Textbuilder() {
  return new TextBuilderInstance()
}

/*
NewTextbuilder()
    tb.add('Sie trinken')
    .compare(1, 3, {
        '>': 'mehr als',
        '<': 'weniger',
        '=': 'gleichviel wie',
    })
    .plural(1, {
        '0': '',
        '1': 'Tasse',
        '2': 'Tassen',
    })
    .add('Kaffee pro')
     .build()
    
    Tag als die anderen Teilnehmenden und')
    .compare(1, 5, {
        '>': 'mehr als',
        '<': 'weniger al',
        '=': 'gleichviel wie',
    })
    .add("der Schweizer im Schnitt.")
    .build()


*/
